module.exports = __webpack_public_path__ + "img/logo.e35fa82c.png";